/* eslint-disable */
import React, { use, useEffect } from 'react';
/* eslint-disable */
import ReactDOM from 'react-dom';
import './index.css';
// import './clarity';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Main from './store/Main';
import * as Sentry from "@sentry/react";

import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./redux-store";
import 'bootstrap/dist/css/bootstrap.min.css';
// import MainNew from './store/MainNew';

Sentry.init({
  dsn: "https://022245f316221e30ab3979435afc5703@sentry.enabill.dev/2",
  integrations: [
    new Sentry.Integrations.Breadcrumbs({
      console: false
    })
  ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
  tracesSampleRate: 1,
});

// Decide router or no-router based on env

const appName = process.env.REACT_APP_NAME;
const slugFromEnv = appName !== 'null' ? appName : null;
const baseName = slugFromEnv ? `/${slugFromEnv}` : `:/slug`;
  console.log( slugFromEnv, baseName , "baseName")
  
ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        {slugFromEnv == null ? 
          <BrowserRouter >
            <Switch>
              <Route path='/:slug'>
                  <Main />
              </Route>
            </Switch> 
          </BrowserRouter>
          :
          <BrowserRouter basename={baseName}>
            <Main />
          </BrowserRouter>
        }
      </I18nextProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
